import request from '@/utils/request'
const BASE_URL = '/PoParent'

//家长账号
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  resetPwd(data) {
    return request({
      url: BASE_URL + '/ResetPwd',
      method: 'post',
      data
    })
  },
  //发送注册验证码
  sendRegCode(mobile) {
    return request({
      url: BASE_URL + '/SendRegCode',
      method: 'post',
      data: mobile
    })
  },
  //发送登录验证码
  sendLoginCode(mobile) {
    return request({
      url: BASE_URL + '/SendLoginCode',
      method: 'post',
      data: mobile
    })
  },
  //注册
  reg(data) {
    return request({
      url: BASE_URL + '/Reg',
      method: 'post',
      data
    })
  },
}